// src/components/Hero/HeroBanner.js
import React, { useState, useEffect, useCallback } from "react";
import { bannerImages } from "../../data/products";
import "./HeroBanner.css";

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  const goTo = useCallback((idx) => {
    if (transitioning) return;
    setTransitioning(true);
    setTimeout(() => { setCurrent(idx); setTransitioning(false); }, 300);
  }, [transitioning]);

  useEffect(() => {
    const t = setInterval(() => goTo((current + 1) % bannerImages.length), 5000);
    return () => clearInterval(t);
  }, [current, goTo]);

  const slide = bannerImages[current];

  return (
    <section className="hero">
      <div className={`hero__panels ${transitioning ? "hero__panels--fade" : ""}`}>
        {/* Left panel */}
        <div className="hero__panel hero__panel--left">
          <img src={slide.mainImg} alt={slide.title} className="hero__img" />
          <div className="hero__panel-overlay hero__panel-overlay--left" />
        </div>

        {/* Center panel — main */}
        <div className="hero__panel hero__panel--center">
          <img src={slide.sideImg1} alt={slide.title} className="hero__img" />
          <div className="hero__center-text">
            <span className="hero__label">EXPLORE</span>
            <h1 className="hero__title">{slide.title}</h1>
          </div>
        </div>

        {/* Right panel */}
        <div className="hero__panel hero__panel--right">
          <img src={slide.sideImg2} alt={slide.subtitle} className="hero__img" />
          <div className="hero__right-text">
            <span className="hero__tag" style={{ color: slide.accentColor }}>{slide.tag}</span>
            <div className="hero__summer">
              <span style={{ color: slide.accentColor, fontFamily: "var(--font-display)", fontSize: 28, fontWeight: 900, letterSpacing: 2 }}>
                SUMMER'26
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Prev/Next arrows */}
      <button className="hero__arrow hero__arrow--prev" onClick={() => goTo((current - 1 + bannerImages.length) % bannerImages.length)} aria-label="Previous">
        <svg width="10" height="18" viewBox="0 0 10 18" fill="none">
          <path d="M9 1L1 9L9 17" stroke="black" strokeWidth="2.5" strokeLinecap="round"/>
        </svg>
      </button>
      <button className="hero__arrow hero__arrow--next" onClick={() => goTo((current + 1) % bannerImages.length)} aria-label="Next">
        <svg width="10" height="18" viewBox="0 0 10 18" fill="none">
          <path d="M1 1L9 9L1 17" stroke="black" strokeWidth="2.5" strokeLinecap="round"/>
        </svg>
      </button>

      {/* Dots */}
      <div className="hero__dots">
        {bannerImages.map((_, i) => (
          <button key={i} className={`hero__dot ${i === current ? "hero__dot--active" : ""}`} onClick={() => goTo(i)} aria-label={`Slide ${i + 1}`} />
        ))}
      </div>
    </section>
  );
}
